function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m437.02 330.98c-27.883-27.882-61.071-48.523-97.281-61.018 38.782-26.711 64.261-71.414 64.261-121.96 0-81.607-66.393-148-148-148s-148 66.393-148 148c0 50.548 25.479 95.251 64.262 121.96-36.21 12.495-69.398 33.136-97.281 61.018-48.352 48.353-74.981 112.64-74.981 181.02h40c0-119.1 96.897-216 216-216s216 96.897 216 216h40c0-68.38-26.629-132.67-74.98-181.02zm-181.02-74.98c-59.551 0-108-48.448-108-108s48.449-108 108-108 108 48.448 108 108-48.449 108-108 108z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    fill: "#FFF",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.f914873c.svg";
export { ForwardRef as ReactComponent };